/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Drupoz } from './drupoz.model';
import { SubjectContactEntity } from './subjectContactEntity.model';
import { TaxReturnRegion } from './taxReturnRegion.model';


export interface CustomerTaxReturn { 
    assemblerEmail?: string;
    assemblerFirstname?: string;
    assemblerPhone?: string;
    assemblerSurname?: string;
    assemblerTitle?: string;
    authorizedSignerFirstname?: string;
    authorizedSignerPosition?: string;
    authorizedSignerSurname?: string;
    cntPurchaseCase?: number;
    created?: string;
    epoBuildingsFileName?: string;
    fileName?: string;
    fileOrder: number;
    generateBuildingsFromAppData: boolean;
    hasControlFile?: boolean;
    id?: number;
    includeOtherConcerned?: boolean;
    includePurchaseCase?: boolean;
    includePze?: boolean;
    includeSjm?: boolean;
    operateAgriAndFishProduction: boolean;
    pze?: Drupoz;
    region?: TaxReturnRegion;
    regionId: number;
    subject?: SubjectContactEntity;
    subjectId: number;
    taxOffice?: number;
    taxWorkplace?: number;
    useRentedAcreage: boolean;
    yearTo?: number;
}

